/* Vendor */
import $ from 'jquery'
window.$ = $;
import 'bootstrap';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';

/* Vendor + Site styles */

import './logged-out.scss';